import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    paddingVertical: 8,
    borderRadius: 0,
    justifyContent: 'center',
  },
});



// WEBPACK FOOTER //
// ./src/components/third-party/Dropdown/src/components/item/styles.js